<div
    class="detailed-notification"
    [class.success]="data.success"
    [class.error]="!data.success"
>
    <span class="icon">
        <mat-icon *ngIf="data.success" fontSet="material-icons-outlined">check_circle</mat-icon>
        <mat-icon *ngIf="!data.success" fontSet="material-icons-outlined">error</mat-icon>
    </span>
    <div class="right-container">
        <span class="message">{{ data.message }}</span>
        <a *ngIf="data.link && data.linkLabel" [href]="data.link" target="_blank" class="link">
            {{ data.linkLabel }}
        </a>
        <div *ngIf="data.showCopyError" class="error-copy-container">
            <app-custom-button
                type="stroked"
                color="primary"
                [text]="data.copyErrorLabel || 'Copy error'"
                (buttonClick)="copyErrorLog()"
            ></app-custom-button>
            <app-custom-button
                *ngIf="data.errorLog"
                type="stroked"
                color="primary"
                [text]="data.downloadErrorLabel || 'Download error'"
                (buttonClick)="downloadErrorLog()"
            ></app-custom-button>
        </div>
    </div>
    <app-custom-button
        *ngIf="data.showClose"
        icon="close"
        color="warn"
        [showButton]="true"
        (buttonClick)="closeSnackbar()"
        aria-label="Close"
    ></app-custom-button>
</div>
